<template>
  <figure @click='nextOrPrev' :class='{phone: size == "phone", gallery: true}'>
    <div v-for='(imageuuid, index) in fileuuids' :class='getClass(index)' :key='index'>
      <srcset :file="fileByUuid(files, imageuuid)" :sizes='sizes' />
    </div>
    <nav v-if='fileuuids.length > 1'>
      <arrow class='right' direction='left' />
      <arrow class='left' direction='right' />
    </nav>
    <footer>
      <i v-if='fileuuids.length > 1'>{{current+1}} / {{fileuuids.length}}</i>
      <figcaption v-html='getCaption(current)'/>
    </footer>
  </figure>
</template>

<script>
import mixins from '.././mixins.js'
export default {
  mixins: [mixins],
  props: ['files', 'fileuuids', 'sizes'],
  data: function() {
    return {
      current: 0
    }
  },
  methods: {
    getClass: function(index){
      if(index == this.current) return 'current';
      if(index == (this.current + 1 < this.fileuuids.length ? this.current + 1 : 0)) return 'next';
      if(index == (this.current - 1 >= 0 ? this.current - 1 : this.fileuuids.length-1)) return 'prev';
    },
    next: function(){
      this.current = this.current + 1 < this.fileuuids.length ? this.current + 1 : 0;
    },
    nextOrPrev: function(event){
      let distance = (event.clientX-(window.innerWidth/2));
      if (distance >= 0) this.current = this.current + 1 < this.fileuuids.length ? this.current + 1 : 0;
      if (distance < 0) this.current = (this.current - 1 >= 0 ? this.current - 1 : this.fileuuids.length-1);
    },
    getCaption(current){
      var file = current ? this.fileByUuid(this.files, this.fileuuids[current]) : false;
      return file && file.meta ? file.meta.caption : '';
    }
  }
}
</script>

<style scoped>

figure {
  box-sizing: border-box;
  position: relative;
  left: calc( ((100vw - var(--main-max-width) ) / -2) - 2.5rem );
  width: 100vw;
  overflow: hidden;
  height: 48rem;
}

figure.phone {
  box-sizing: border-box;
  position: relative;
  left: -2.5rem;
  width: 100vw;
  overflow: hidden;
  height: 24rem;
}


figure > div {
  will-change: transform, opacity;
  display: none;
  width: calc(var(--main-max-width) - 5rem);
  top: 0;
  bottom: 2.5rem;
  left: 0;
  right: 0;
  position: absolute;
  margin: auto;
  transition: transform 0.5s ease-in-out, opacity 1s ease-in-out 0.5;
}

figure.phone > div {
  width: 80vw;
}


figure > div img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

figure div.current {
  display: block;
  z-index: 2;
  opacity: 1;
}

figure div.next {
  display: block;
  transform: translateX( calc( ((100vw - var(--main-max-width) ) / -2) - 5rem + 100vw));
  z-index: 0;
  opacity: 0.15;
}

figure div.prev {
  display: block;
  transform: translateX( calc( ((100vw - var(--main-max-width) ) / -2) - 2.5rem - var(--main-max-width) + 7.5rem ) );
  z-index: 1;
  opacity: 0.15;
}

i {
  font-style: normal;
}

footer {
  width: calc(var(--main-max-width) - 5rem);
  margin: auto;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  box-sizing: border-box;
}

figure.phone footer {
  width: var(--main-max-width);
  padding: var(--main-padding);
}

figcaption {
  position: absolute;
  bottom: 0;
  right: 5rem;
  left: 5rem;
  margin: auto;
  text-align: center;
}

nav div {
  position: absolute;
  top: -4rem;
  bottom: 0;
  height: 4.75rem;
  margin: auto;
  z-index: 99;
  cursor: pointer;
  transition: transform 0.25s ease-out;
}

nav div:hover {
  transform: scale(1.05);
}

nav div:active {
  transform: scale(0.85);
}

nav div.right {
  right: 3.5rem;
}

figure.phone nav div.right {
  right: 1rem;
}

nav div.left {
  left: 3.5rem;
}

figure.phone nav div.left {
  left:1rem;
}

</style>

<style>
figure.gallery > div img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
</style>
